import './ColorPicker.css'
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState,useEffect } from "react";
import { ChromePicker } from "react-color";


const ColorPicker = ({
  onColorChange,
  setShowColorPicker,
  color,
}) => {
  const [selectedColor, setSelectedColor] = useState("");

  const ColorChangeHandler = (color) => {
    console.log("--- color --> ", color);
    setSelectedColor(color?.hex);
    onColorChange(color?.hex);
  };

  useEffect(() => {
    setSelectedColor(color);
  }, []);

  return (
    <div className="color-picker-wrapper">
      <div
        style={{
          textAlign: "right",
          padding: "5px 10px",
        }}
      >
        <FontAwesomeIcon
          icon={faXmark}
          className="picker-tool-icon"
          onClick={() => setShowColorPicker(false)}
        />
      </div>
      <ChromePicker color={selectedColor} onChange={ColorChangeHandler} />
    </div>
  );
};

export default ColorPicker